import Layout from "@/views/layout/Layout";

const medicalRecordRouter = {
  path: "/medicalRecordMan",
  component: Layout,
  name: "medicalRecordMan",
  meta: {
    title: "病历管理",
    icon: "blbl",
    roles: ["bingliguanli"]
  },
  children: [
    {
      path: "mailHanEMS",
      component: () => import("@/views/medicalRecord/mailHanEMS/index"),
      meta: {
        title: "邮寄办理(邮政EMS)",
        roles: ["youjibanli_ems_jyt"]
      },
      alwaysShow: true,
      children: [
        {
          path: "mailReceive",
          component: () =>
            import("@/views/medicalRecord/mailHanEMS/mailReceive2"),
          name: "邮寄接收",
          meta: {
            title: "邮寄接收",
            roles: ["youjijieshou_ems_jyt"]
          },
          children: []
        },
        {
          path: "mailExport",
          component: () =>
            import("@/views/medicalRecord/mailHanEMS/mailExport"),
          name: "邮寄导出",
          meta: {
            title: "邮寄导出",
            roles: ["youjijieshou_ems_jyt"]
          },
          children: []
        },
        {
          path: "waitMailQuery",
          component: () =>
            import("@/views/medicalRecord/mailHanEMS/waitMailQuery"),
          name: "待邮查询",
          meta: {
            title: "待邮查询",
            roles: ["daiyouchaxun_ems_jyt"]
          },
          children: []
        },

      ]
    },
    {
      path: "mailHanJD",
      component: () => import("@/views/medicalRecord/mailHanJD/index"),
      meta: {
        title: "邮寄办理(京东物流)",
        roles: ["youjibanli_jd_jyt"]
      },
      alwaysShow: true,
      children: [
       
        {
          path: "mailReceive",
          component: () =>
            import("@/views/medicalRecord/mailHanJD/mailReceive2"),
          name: "邮寄接收",
          meta: {
            title: "邮寄接收",
            roles: ["youjijieshou_jd_jyt"]
          },
          children: []
        },
        {
          path: "mailExport",
          component: () => import("@/views/medicalRecord/mailHanJD/mailExport"),
          name: "邮寄导出",
          meta: {
            title: "邮寄导出",
            roles: ["youjidaochu_jd_jyt"]
          },
          children: []
        },
        {
          path: "waitMailQuery",
          component: () =>
            import("@/views/medicalRecord/mailHanJD/waitMailQuery"),
          name: "待邮查询",
          meta: {
            title: "待邮查询",
            roles: ["daiyouchaxun_jd_jyt"]
          },
          children: []
        },
        
      ]
    },
    {
      path: "mailHanSF",
      component: () => import("@/views/medicalRecord/mailHanSF/index"),
      meta: {
        title: "邮寄办理(顺丰快递)",
        roles: ["youjibanli_sf_jyt"]
      },
      alwaysShow: true,
      children: [
       
        {
          path: "mailReceive",
          component: () =>
            import("@/views/medicalRecord/mailHanSF/mailReceive2"),
          name: "邮寄接收",
          meta: {
            title: "邮寄接收",
            roles: ["youjijieshou_sf_jyt"]
          },
          children: []
        },
        {
          path: "mailExport",
          component: () => import("@/views/medicalRecord/mailHanSF/mailExport"),
          name: "邮寄导出",
          meta: {
            title: "邮寄导出",
            roles: ["youjidaochu_sf_jyt"]
          },
          children: []
        },
        {
          path: "waitMailQuery",
          component: () =>
            import("@/views/medicalRecord/mailHanSF/waitMailQuery"),
          name: "待邮查询",
          meta: {
            title: "待邮查询",
            roles: ["daiyouchaxun_sf_jyt"]
          },
          children: []
        },
        
      ]
    },
  ]
};

export default medicalRecordRouter;
